"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._InventorySchedule = {
    type: "structure",
    required: ["Frequency"],
    members: {
        Frequency: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_InventorySchedule.js.map